import React from 'react';
import Filter, { FilterModal, FilterSection } from './Filter';
import CheckboxFilterByType from './FilterComponents/CheckboxFilterByType';

import styles from '../search.scss';

const BallTypeFilter = (props) => {
    const { filters, filterModal, handleFilterClick, closeModals, filterInputs, searchTypes, handleFilterSubmit, clearFilters, handleFilterUpdate, mobileOnly, desktopOnly, 'data-testid': dataTestId } = props;

    return (
        <div className={styles.filterWrapper}>
            <Filter
                filterName={'ballType'}
                handleFilterClick={handleFilterClick}
                isActive={(filters && filters.ballTypes && Object.values(filters.ballTypes).indexOf(true) > -1) || filterModal === 'ballType'}
                mobileOnly={mobileOnly}
                desktopOnly={desktopOnly}
                data-testid={dataTestId}
            >
                Ball Type
            </Filter>
            {filterModal === 'ballType' && (
                <FilterModal
                    title={'Ball Type'}
                    handleFilterSubmit={handleFilterSubmit}
                    onCloseClick={closeModals}
                    clearFilters={() => clearFilters('ballType')}
                    data-testid={dataTestId}
                >
                    <FilterSection>
                        <CheckboxFilterByType
                            searchTypes={searchTypes}
                            searchTypesPropName={`ballTypes`}
                            filterInputs={filterInputs}
                            filtersPropName={`ballTypes`}
                            onChange={(value) => {
                                handleFilterUpdate({
                                    ballTypes: {
                                        ...filterInputs.ballTypes,
                                        [value]: !filterInputs.ballTypes[value],
                                    },
                                });
                            }}
                            data-testid={dataTestId && `${dataTestId}.options`}
                        />
                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

export default BallTypeFilter;
